import request from '@/utils/request'
// 营业额数据
// export const getTurnoverDataes = (data) =>
//   request({
//     'url': `/report/turnoverStatistics`,
//     'method': 'get',
//     data
//   })
// 首页数据
// // 今日数据
// export const getTodayDataes = () =>
//   request({
//     'url': `/workspace/todaydate`,
//     'method': 'get'
//   })
// 订单管理
  export const getOrderData = () =>
  request({
    'url': `/workspace/overviewOrders`,
    'method': 'get'
  })
// 菜品总览
export const getOverviewDishes = () =>
request({
  'url': `/workspace/overviewDishes`,
  'method': 'get'
})
// 套餐总览
export const getSetMealStatistics = () =>
request({
  'url': `/workspace/overviewSetmeals`,
  'method': 'get'
})
// 营业数据
export const getBusinessData= (params: any) =>
request({
  'url': `/workspace/businessData`,
  'method': 'get',
  params
})
/**
 *
 * 报表数据
 *
 **/
// 统计
// 获取当日销售数据 -> 顶部数据
// export const getDataes = (params: any) =>
//   request({
//     'url': `/report/amountCollect/${params.date}`,
//     'method': 'get'
//   })


// 营业额统计
export const getTurnoverStatistics= (params: any) =>
  request({
    'url': `/report/turnoverStatistics`,
    'method': 'get',
    params
  })

// 用户统计
export const getUserStatistics= (params: any) =>
  request({
    'url': `/report/userStatistics`,
    'method': 'get',
    params
  })
  // 用户统计
export const getPlayerStatistics= (params: any) =>
  request({
    'url': `/report/playerStatistics`,
    'method': 'get',
    params
  })
  // 订单统计
export const getOrderStatistics= (params: any) =>
request({
  'url': `/report/ordersStatistics`,
  'method': 'get',
  params
})
  // 销量排名TOP10
  export const getTop= (params: any) =>
  request({
    'url': `/report/top10`,
    'method': 'get',
    params
  })
  // 数据概览
  export const getDataOverView= (params: any) =>
  request({
    'url': `/report/dataOverView`,
    'method': 'get',
    params
  })
  // 导出
  export function exportInfor(params: any) {
    return request({
      url: '/report/export',
      method: 'get',
      params,
      responseType: "blob"
    })
  }

  // 下载参赛选手模板
  export function exportInforOne(params: any) {
    return request({
      url: '/report/export/one',
      method: 'get',
      params,
      responseType: "blob"
    })
  }

  // 下载赛事轮模板
  export function exportInforTwo(params: any) {
    return request({
      url: '/report/export/two',
      method: 'get',
      params,
      responseType: "blob"
    })
  }

 // 获取当前赛事的赛事直播开关状态
 export const getLiveStreamingStatus= () =>
  request({
    'url': `/competition/liveStreamingStatus/top`,
    'method': 'get',
  })

  // 修改当前赛事的赛事直播开关状态
export const enableOrDisableLiveStreamingStatus = (params: any) => {
  return request({
    url: `/competition/switched/${params.liveStreamingStatus}`,
    method: 'post',
    params: { id:params.id}
  })
}

// 修改礼物开关状态
export const enableOrDisableGiftStatus = (params: any) => {
    return request({
      url: `/competition/gift/${params.gift}`,
      method: 'post',
      params: { id:params.id}
    })
  }

  // 修改成绩展示开关状态
export const enableOrDisableScoreStatus = (params: any) => {
    return request({
      url: `/competition/score/${params.score}`,
      method: 'post',
      params: { id:params.id}
    })
  }

// 修改免费投票次数和增加的热度
export const updateVotesAndHots = (params: any) => {
    return request({
      url: '/competition/votesAndHots',
      method: 'post',
      params: {
        id:params.id,
        votes: params.votes,
        hots: params.hots
      }
    })
}

